import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

//统计分析
const GetCruiseAnalyzeByCity = `${urlPrefix}/AnalyzeCruise/ByCity`
const GetEventAnalyze = `${urlPrefix}/AnalyzeEvent`
const GetUnitAnalyze = `${urlPrefix}/AnalyzeUnit`
const GetUnitRiskAnalyze = `${urlPrefix}/AnalyzeUnitRisk`

const GetCruiseAnalyze = `${urlPrefix}/AnalyzeCruise`
const GetCruiseLogsAnalyze = `${urlPrefix}/AnalyzeCruiseLogs`
const GetCruiseLogDetails = `${urlPrefix}/AnalyzeCruiseLogs/details`

//动态列
export interface ColItemData {
    Id: number
    TableName: string
    GroupType: string
    GroupId: number
    FieldName: string//对应数据源中的列名
    GroupName: string//父列名称
    LabelName: string//子列名称
    Query: string
    Childs: ColItemData[]
}

export class CruiseLogData {
    [key: string]: any
    TaskId: number
    TaskDetailId: number
    /** 任务分配对象，组织/机构/个人*/
    TaskAssignTo: string
    TaskStart: Date | null
    TaskEnd: Date | null
    /** 任务生成时间*/
    TaskCreatedDate: Date | null
    /** 0删除 1未巡查 2已巡查 3过期*/
    TaskDetailStatus: number

    PlanId: number
    PlanName: string
    /** 1小时 2天 */
    ScheduleType: number

    UnitId: number
    UnitCode: string
    UnitName: string
    CityId: number
    CountyId: number
    LevelId: number
    PointId: number
    PointName: string

    MakeupId: number
    CruiseId: number
    EventId: number
    TrackId: number
    /** 巡查分类：0:巡查 1：事件*/
    CruiseType: number
    /** 巡查日期，返回datetime类型，web前段做格式化*/
    CruiseAt: Date | null
    /** 巡查日期，返回格式化之后的日期 app端直接展示*/
    CruiseDate: string
    /** 是否过期*/
    IsExpired: boolean
    /** 过期日期，返回datetime类型，web前段做格式化*/
    ExpiredAt: Date | null
    /** 过期日期，返回格式化之后的日期 app端直接展示*/
    ExpiredDate: string
    /** 是否是巡查任务*/
    IsTask: boolean
    CruiserId: number
    /** 巡查人*/
    Cruiser: string
    /** 问题类型*/
    IssueCategory: string
    /** 巡查地址*/
    CruiseAddress: string
    /** 最新操作日期 巡查日期，过期日期，未巡查(GETDATE())*/
    ActionDate: Date
    constructor() {
        this.TaskId = 0
        this.TaskDetailId = 0
        /** 任务分配对象，组织/机构/个人*/
        this.TaskAssignTo = ''
        this.TaskStart = null
        this.TaskEnd = null
        /** 任务生成时间*/
        this.TaskCreatedDate = null
        /** 0删除 1未巡查 2已巡查 3过期*/
        this.TaskDetailStatus = 0

        this.PlanId = 0
        this.PlanName = ''
        /** 1小时 2天 */
        this.ScheduleType = 0

        this.UnitId = 0
        this.UnitCode = ''
        this.UnitName = ''
        this.CityId = 0
        this.CountyId = 0
        this.LevelId = 0
        this.PointId = 0
        this.PointName = ''

        this.MakeupId = 0
        this.CruiseId = 0
        this.EventId = 0
        this.TrackId = 0
        /** 巡查分类：0:巡查 1：事件*/
        this.CruiseType = 0
        /** 巡查日期，返回datetime类型，web前段做格式化*/
        this.CruiseAt = null
        /** 巡查日期，返回格式化之后的日期 app端直接展示*/
        this.CruiseDate = ''
        /** 是否过期*/
        this.IsExpired = false
        /** 过期日期，返回datetime类型，web前段做格式化*/
        this.ExpiredAt = null
        /** 过期日期，返回格式化之后的日期 app端直接展示*/
        this.ExpiredDate = ''
        /** 是否是巡查任务*/
        this.IsTask = false
        this.CruiserId = 0
        /** 巡查人*/
        this.Cruiser = ''
        /** 问题类型*/
        this.IssueCategory = ''
        /** 巡查地址*/
        this.CruiseAddress = ''
        /** 最新操作日期 巡查日期，过期日期，未巡查(GETDATE())*/
        this.ActionDate = new Date()
    }
}

//巡查情况统计
export const getCruiseLogsAnalyze = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetCruiseLogsAnalyze,
        params: param
    })
}
//巡查情况统计 点击查看明细
export const getCruiseLogDetails = (data?: any) => {
    return tryAxios({
        method: 'post',
        url: GetCruiseLogDetails,
        data: data
    })
}
//日常巡查
export const getCruiseAnalyzeByCity = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetCruiseAnalyzeByCity,
        params: param
    })
}
//日常巡查 新
export const getCruiseAnalyze = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetCruiseAnalyze,
        params: param
    })
}
//问题上报
export const getEventAnalyze = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetEventAnalyze,
        params: param
    })
}

//文保单位统计
export const getUnitAnalyze = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetUnitAnalyze,
        params: param
    })
}

//文保单位风险评估统计
export const getUnitRiskAnalyze = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetUnitRiskAnalyze,
        params: param
    })
}
